import {
  Body,
  Button,
  getImgProps,
  getPictureProps,
  Grid,
  Heading,
  Link,
  scrollIntoView,
  TextVerticalSpacer,
} from '@superhi/design'
import React from 'react'

import { ID } from '../Plans'

import Point from './components/Point'
import { Wrapper, Content, Points, BackgroundImage } from './styles'

import { WrapperProps } from 'src/components/page-headers/styles'
import { buildPath } from 'src/routing'

const GRID_1_CELL_SPAN_1: Record<
  WrapperProps['$align'],
  React.ComponentProps<typeof Grid.Cell>['span']
> = {
  left: { small: 'full', medium: 'full', large: 7, xlarge: 6 },
  center: { small: 'full', medium: 'full', large: [2, 11], xlarge: [3, 10] },
}

const GRID_1_ROW_GAP = { small: 32, medium: 48 }

const backgroundImageProps = getPictureProps({
  small: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/teams/teams-hero.png',
    width: 100,
    options: {
      ar: '200:100',
      fit: 'crop',
      fm: 'jpg',
    },
  },
  medium: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/teams/teams-hero.png',
    width: 100,
    options: {
      fm: 'jpg',
    },
  },
  large: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/teams/teams-hero.png',
    width: 100,
    options: {
      fm: 'jpg',
    },
  },
  xlarge: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/teams/teams-hero.png',
    width: 100,
    options: {
      fm: 'jpg',
    },
  },
})

type Props = {}

export const Hero: React.FC<React.PropsWithChildren<Props>> = ({ ...commonProps }) => (
  <Wrapper data-component-name="Hero" {...commonProps} $align="center" $compact={false}>
    <BackgroundImage alt="" {...backgroundImageProps} backgroundColor="WHITE" />

    <Grid rowGap={GRID_1_ROW_GAP}>
      <Grid.Cell span={GRID_1_CELL_SPAN_1['center']}>
        <Content>
          <TextVerticalSpacer>
            <Heading level="1" color="BLUE_50">
              SuperHi For Teams
            </Heading>
            <Body level="1">
              <span>SuperHi For Teams offers</span>{' '}
              <Link href={buildPath('membership-product')}>Unlimited memberships </Link>
              <span>
                to all creative teams, big and small. Each team member gets access to all our
                design, code, and project management courses, plus extra benefits!
              </span>
            </Body>
          </TextVerticalSpacer>

          <Points>
            <Point>Tailored learning</Point>
            <Point>Upskilled staff</Point>
            <Point>Improved retention</Point>
          </Points>

          <Button level="1" onClick={() => scrollIntoView(ID)}>
            See our plans
          </Button>
        </Content>
      </Grid.Cell>
    </Grid>
  </Wrapper>
)

export default Hero
